import { useCallback, useEffect, useState } from 'react'
import * as _ from 'lodash'

function useSearch(keyword: string) {
    const [debounceString, setDebounceString] = useState<any>('')
    const [searchString, setSearchString] = useState<any>('')
    const ac = new AbortController()

    const debounceSearch = _.debounce(setDebounceString, 400)

    useEffect(() => {
        setSearchString(searchString)
        setDebounceString(searchString)
        return () => {
            ac.abort()
        }
    }, [keyword])

    const setDebounceSearch = useCallback((e: string) => {
        debounceSearch(e)
        setSearchString(e)
    }, [])

    return [{ searchString, debounceString }, setDebounceSearch] as const
}

export default useSearch
